

import { Suspense, useEffect, useState } from "react";

import RemoteErrorBoundary from "../error-boundary";


export default function ArtLiveLoader() {
  const [GatewayComponent, setGatewayComponent]: any = useState(null);
  useEffect(() => {
    async function loadModule() {
      try {
        const module = await import("art_liveconnect/gateway");
        setGatewayComponent(() => module.default);
      } catch (error) {
        console.error("Remote module 'art_liveconnect' failed to load. Falling back.");
        setGatewayComponent(() => () => <div>Feature Unavailable</div>);
      }
    }

    loadModule();
  }, []);

  if (!GatewayComponent) return <div>Loading Gateway...</div>;

  return (
    <Suspense fallback={<div>Loading Gateway...</div>}>
      <RemoteErrorBoundary>
      <GatewayComponent />
      </RemoteErrorBoundary>
    </Suspense>
  );
}
